<template>
    <button
        type="button"
        class="tw:inline-flex tw:items-center tw:px-4 tw:py-2 tw:border tw:border-transparent
               tw:font-medium tw:font-sans tw:rounded-md tw:shadow-xs tw:text-white tw:bg-hiorg-hellrot-600
               tw:focus:outline-hidden tw:focus:ring-2 tw:focus:ring-offset-2 tw:focus:ring-hiorg-hellrot-500"
        :class="setDisabled ? 'tw:opacity-20' : 'tw:hover:bg-hiorg-hellrot-500'"
        :disabled="setDisabled"
    >
        {{ text }}
    </button>
</template>

<script setup lang="ts">

defineProps<{
    text: string;
    setDisabled: boolean;
}>();
</script>
